import React from 'react'
import { Typography, FormGroup } from '@mui/material'
import { FormControlLabel, Checkbox } from '@mui/material'

// NEVO-439 - Limitar ACVC post portal único: el selector de gestión de demandas (captadora/
// grabadora) queda en modo consulta para todos los perfiles salvo Prescriptor.
export const CompanyWorksChecklist = ({ options, formState, onChange, readOnly = false }) => {
  const handleChange = (e) => {
    const { name, checked } = e.target
    if (options.some((option) => formState[option.key] && option.key !== name)) {
      onChange({ target: { name, value: checked } })
    }
  }

  return (
    <FormGroup>
      {options.map((option) => (
        <FormControlLabel
          key={option.key}
          style={{ pointerEvents: 'none' }}
          control={
            <Checkbox
              style={{ pointerEvents: readOnly ? 'none' : 'auto', padding: 10 }}
              color="primary"
              checked={!!formState[option.key]}
              onChange={handleChange}
              disabled={readOnly}
              name={option.key}
            />
          }
          label={<Typography variant="body1">{option.label}</Typography>}
        />
      ))}
    </FormGroup>
  )
}
